/*
 * Want to add a service? go/generator-shared-service
 */

export default angular.module('searchEngineFrontend.app.shared.services', [
]);



// WEBPACK FOOTER //
// ./src/app/shared/services/index.js